import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.table = [];
    this.cardsLayout = [
      // cards

      {
        title: "card3",
        hideTitle: true,
        items: this.table
      }
    ];
  }

  buildTableTitle = () => {
    const titles = [
      ["Vendor", "Vendor"],
      ["AP Vendor", "APVendor"],
      ["Master Vendor", "MasterVendor"],
      ["Name", "Name"],
      ["OR", "OR"],
      ["SH", "SH"],
      ["PM", "PM"]
    ];
    for (let x = 1; x < 8; x++) {
      this.table.push({
        label: {
          value: titles[x - 1][0]
        },
        span: {
          value: titles[x - 1][0],
          alignment: "center",
          size: "100%"
        },
        item: {
          node: "onlySpan",
          value: "",
          intemName: titles[x - 1][1]
        },
        size: x === 4 ? "42%" : x === 5 ? "5%" : "calc(53% / 5)"
      });
    }
  };
  buildTable = () => {
    const outputs = [
      ".vendor",
      ".apRefNo",
      ".masterVendor",
      ".vendName",
      ".orderMethod",
      ".shipMethod",
      ".designatedPM",
      ".vendor",
      ".apRefNo",
      ".masterVendor",
      ".vendName",
      ".orderMethod",
      ".shipMethod",
      ".designatedPM",
      ".vendor",
      ".apRefNo",
      ".masterVendor",
      ".vendName",
      ".orderMethod",
      ".shipMethod",
      ".designatedPM",
      ".vendor",
      ".apRefNo",
      ".masterVendor",
      ".vendName",
      ".orderMethod",
      ".shipMethod",
      ".designatedPM",
      ".vendor",
      ".apRefNo",
      ".masterVendor",
      ".vendName",
      ".orderMethod",
      ".shipMethod",
      ".designatedPM"
    ];
    var count = 1;
    for (let row = 1; row < 6; row++) {
      for (let x = 1; x < 8; x++) {
        this.table.push({
          label: {
            value: ` . `,
            align: "center"
          },
          item: {
            node: "input",
            type: "string",
            value: "",
            noInput: true,
            intemName: `[${row - 1}]${outputs[x - 1]}`
          },
          size: x === 4 ? "42%" : x === 5 ? "5%" : "calc(53% / 5)",

          readOnly: true
        });
        count++;
      }
    }
  };

  componentDidMount() {
    this.buildTableTitle();
    this.buildTable();
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value = props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <InputCard
        jsonObj={this.cardsLayout[0]}
        setCardsInfo={this.getCardsInfo}
        functions={{
          checkOrderConstraints: this.props.checkOrderConstraints
        }}
        flex={1}
      />
    );
  };
  getTheJson = () => {
    for (let index = 0; index < this.cardsLayout.length; index++) {
      for (let i = 0; i < this.cardsLayout[index].items.length; i++) {
     
      }
    }
  };
  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}

        <div className="cards-container" style={{ flec: 1, display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
